export default __webpack_public_path__ + "static/InDevelopment-89a30f1c735d3942d7c2fd8c05f38c58.png";